import { Observable } from 'rxjs';
import _ from 'lodash';

import DonationSchedulesApi from 'entities/donationSchedule/api';
import { selectDonationScheduleById } from 'entities/donationSchedule/selectors';
import { selectUser } from 'entities/user/selectors';
import { Privileges } from 'utils/privileges';

import { initSuccessAction, initFailedAction } from './actions';
import { INIT, CANCEL_DONATION_SCHEDULE } from './constants';

const init = (action$, store) =>
  action$.ofType(INIT).exhaustMap((payload) => {
    const state = store.getState();
    const user = selectUser(state);

    if (!user?.hasPrivilege(Privileges.DONATION_SCHEDULE_VIEW)) {
      return Observable.of(initSuccessAction());
    }

    const donationSchedule = selectDonationScheduleById(state, payload.id);

    // Strategy: Load basic schedule first (fast), then load donations (slow)
    // This allows showing schedule details immediately while donations load

    if (!donationSchedule) {
      // No schedule in cache - fetch basic first, then full with donations
      return DonationSchedulesApi.getByFilter(
        { id: { equals: payload.id } },
        true // force refetch
      )
        .mergeMap((basicAction) => {
          // Basic schedule loaded, now fetch full with donations
          return Observable.concat(
            Observable.of(basicAction),
            DonationSchedulesApi.fetchById(payload.id).mergeMap((fullAction) => [
              fullAction,
              initSuccessAction(),
            ])
          );
        })
        .catch((e) => Observable.of(initFailedAction(e)));
    }

    if (!donationSchedule.donations) {
      // Schedule exists but no donations - fetch full with donations
      return DonationSchedulesApi.fetchById(payload.id)
        .mergeMap((resultingActions) => [resultingActions, initSuccessAction()])
        .catch((e) => Observable.of(initFailedAction(e)));
    }

    // Already have everything
    return Observable.of(initSuccessAction());
  });

const cancelDonationSchedule = (action$) =>
  action$.ofType(CANCEL_DONATION_SCHEDULE).exhaustMap((payload) =>
    Observable.combineLatest([DonationSchedulesApi.cancelDonationSchedule(payload.id)])
      .mergeMap((resultingActions) => [..._.flatten(resultingActions), initSuccessAction()])
      .catch((e) => Observable.of(initFailedAction(e)))
  );

export default [init, cancelDonationSchedule];
